import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { getPofile, sendMessage, contactMailSend } from '../hooks/auth'

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}


const mapDispatchToProps = dispatch => ({
  getPofile: () => dispatch(getPofile()),
  sendMessage: (data) => dispatch(sendMessage(data)),
  contactMailSend: (bool) => dispatch(contactMailSend(bool))
});

const getValidate = (state) => {
  var first_name = null
  var last_name = null
  var email = null
  var message = null
  var valid = true

  if (state.first_name == null || state.first_name == "") {
    first_name = "Required"
    valid = false
  }
  if (state.last_name == null || state.last_name == "") {
    last_name = "Required"
    valid = false
  }
  if (state.message == null || state.message == "") {
    message = "Required"
    valid = false
  }
  if (state.email == null || state.email == "") {
    email = "Required"
    valid = false
  }else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(state.email)) {
    email = "invalid email address"
    valid = false
  }

  return { data: { first_name: first_name, last_name: last_name, email: email, message:message }, valid }
}

class ContactUs extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      message:"",
      error: {
        first_name: null,
        last_name: null,
        email: null,
        message: null
      }
    };

    this.props.getPofile()
  }

  componentDidUpdate = ()=> {
    if(this.props.auth.profile!=null) {
      this.setState({
       first_name: this.props.auth.profile.first_name,
       last_name: this.props.auth.profile.last_name,
       email: this.props.auth.profile.email
      })
    }
    
    if(this.props.auth.mail && this.state.message !== "") {
      this.props.contactMailSend(false)
      this.setState({message:""})
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: {
        ...this.state.error,
        [e.target.name]: null
      }
    })
  }

  sendMessage = () => {
    if (getValidate(this.state).valid) {
      this.props.sendMessage({
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        email: this.state.email,
        message: this.state.message
      })
    } else {
      this.setState({ error: getValidate(this.state).data })
    }
  }

  render() {
    return <Fragment>

      <NavbarComp/>
      <div className="page-sections">
        <div className="contact-wrap">
          <Container>
            <div className='contact-contents'>
              <h2 className='main-title-style'>Contact Us</h2>
              <div className='contact-form'>
                <Form>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">First Name * {this.state.error.first_name !== null ? <span className="error-span">{this.state.error.first_name}</span> : null}</Form.Label>
                    <Col sm="10">
                      <Form.Control type="text" onChange={this.handleChange} value={this.state.first_name} name="first_name" placeholder="Abraham" />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">Last Name * {this.state.error.first_name !== null ? <span className="error-span">{this.state.error.first_name}</span> : null}</Form.Label>
                    <Col sm="10">
                      <Form.Control type="text" onChange={this.handleChange} value={this.state.last_name} name="last_name" placeholder="Sleepknow" />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">Email * {this.state.error.first_name !== null ? <span className="error-span">{this.state.error.first_name}</span> : null}</Form.Label>
                    <Col sm="10">
                      <Form.Control type="email" onChange={this.handleChange} value={this.state.email} name="email" placeholder="info@sleepknow.com" />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">Message * {this.state.error.first_name !== null ? <span className="error-span">{this.state.error.first_name}</span> : null}</Form.Label>
                    <Col sm="10">
                      <Form.Control as="textarea" onChange={this.handleChange} value={this.state.message} name="message" rows={8} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Col sm="2"></Col>
                    <Col sm="10">
                      <Button variant="primary" onClick={this.sendMessage}>Submit</Button>
                    </Col>
                  </Form.Group>
                </Form>
              </div>
            </div>
          </Container>
        </div>
      </div>
      <FooterComp/>

    </Fragment>
  }
}

ContactUs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);
